// src/config/config.js
const localConfig = {
    apiKey: process.env.REACT_APP_API_KEY,
    factApiKey: process.env.REACT_APP_FACT_API_KEY,
    googleMapKey: process.env.REACT_APP_GOOGLE_MAP_KEY,
};

export default localConfig;
